import { StyledAlert } from "App/global-style";
import { AlertType } from "Components/Form/Alert";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { getYesOrNoOptions } from "Components/Form/RadioButton/radioButtonUtils";
import { useTexts } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { AkaHealthProductDetailsFormValues } from "./akaHealthProductDetailsInterfaces";

interface Props {
  formProps: FormikProps<AkaHealthProductDetailsFormValues>;
}

export const AkaHealthProductDetailsFormElements = ({
  formProps,
}: Props): React.ReactElement => {
  const { getText } = useTexts();

  return (
    <div className="data-hj-suppress">
      <RadioButtonTrueFalse
        name="isFitForWork"
        id="isFitForWork"
        label={getText("akahealthform.label.isfitforwork")}
        options={getYesOrNoOptions("isFitForWork-yes", "isFitForWork-no")}
        direction="vertical"
        error={getError("isFitForWork", formProps)}
      />
      {formProps.values.isFitForWork === BooleanFormType.FALSE && (
        <StyledAlert
          title={getText("akahealthform.alerttitle.isfitforwork")}
          marginBottom="32px"
          type="error"
          alertType={AlertType.STOPPER_ALERT}
          fluid
        />
      )}
      <RadioButtonTrueFalse
        name="isOnSickLeave"
        id="isOnSickLeave"
        label={getText("healthform.label.isonsickleave")}
        options={getYesOrNoOptions("isOnSickLeave-yes", "isOnSickLeave-no")}
        direction="vertical"
        error={getError("isOnSickLeave", formProps)}
      />
      {formProps.values.isOnSickLeave === BooleanFormType.TRUE && (
        <StyledAlert
          title={getText("healthform.alerttitle.isfitforwork")}
          marginBottom="32px"
          type="error"
          alertType={AlertType.STOPPER_ALERT}
          fluid
        />
      )}
      <RadioButtonTrueFalse
        name="inTreatment"
        id="inTreatment"
        label={getText("akahealthform.label.intreatment")}
        options={getYesOrNoOptions("inTreatment-yes", "inTreatment-no")}
        direction="vertical"
        error={getError("inTreatment", formProps)}
      />
      {formProps.values.inTreatment === BooleanFormType.TRUE && (
        <StyledAlert
          title={getText("akahealthform.alerttitle.intreatment")}
          marginBottom="32px"
          type="error"
          alertType={AlertType.STOPPER_ALERT}
          fluid
        />
      )}
      <RadioButtonTrueFalse
        name="isPlannedAnyKindOfTreatment"
        id="isPlannedAnyKindOfTreatment"
        label={getText("akahealthform.label.isplannedanykindoftreatment")}
        options={getYesOrNoOptions(
          "isPlannedAnyKindOfTreatment-yes",
          "isPlannedAnyKindOfTreatment-no",
        )}
        direction="vertical"
        error={getError("isPlannedAnyKindOfTreatment", formProps)}
      />
      {formProps.values.isPlannedAnyKindOfTreatment ===
        BooleanFormType.TRUE && (
        <StyledAlert
          title={getText(
            "akahealthform.alerttitle.isplannedanykindoftreatment",
          )}
          marginBottom="32px"
          type="error"
          alertType={AlertType.STOPPER_ALERT}
          fluid
        />
      )}
    </div>
  );
};
